import BaseModelAPI from '../BaseModelAPI';

export default class PartPurchaseQualityControlConfirmation extends BaseModelAPI {
	static entity = 'partpurchasequalitycontrolconfirmation';
	static entityName = 'partpurchasequalitycontrolconfirmation';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.partPurchaseQualityControlId = '';
			this.partPurchaseQualityControl = {};
			this.partPurchaseQualityControlConfirmationNumber = '';
			this.partPurchaseQualityControlConfirmationDate = '';
			this.revisi = 0;
			this.partPurchaseQualityControlConfirmationDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async downloadQcChecksheet(this_, id) {
        let _this = this;
        return await this_.$http.get(`${this.entityName}/downloadQcChecksheet/${id}`, {responseType: 'blob'})
            .then(async function(response){
                if (response.data) {
                    await saveAs(response.data, _this.entityName + ".xlsx");
                }
                return null;
            })
            .catch(function(error){
                this_.$store.dispatch('addErrorMessageGlobal', error);
                throw error;
            });
    }

}